import React from 'react';
import moment from 'moment';
import { Table, Tag, Typography } from 'antd';

import { useRepresentative } from '@hooks/RepresentativeContext';
import { returnOrderStatus } from '@utils/order-status';
import { SearchOutlined } from '@ant-design/icons';
import TableFilters from '../../../../components/TableFilters';

const { Title, Text } = Typography;
interface OrdersProps {}

const Orders: React.FC<OrdersProps> = () => {
  const { orders, ordersTotal, loadOrdersByRepresentativeIdPaginated, actualRepresentative } = useRepresentative();

  const columns = [
    {
      title: 'Nº Pedido',
      dataIndex: 'orderCode',
      align: 'center' as 'center',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Código'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.orderCode ? record.orderCode.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (pedidoA: any, pedidoB: any) => pedidoA.orderCode - pedidoB.orderCode,
    },
    {
      title: 'Nome da Loja',
      dataIndex: 'customerName',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Nome da Loja'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.customerName ? record.customerName.toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (pedidoA: any, pedidoB: any) => pedidoA.customerName.trim().localeCompare(pedidoB.customerName.trim()),
    },
    {
      title: 'Representante',
      dataIndex: 'representativeName',
      sorter: (pedidoA: any, pedidoB: any) =>
        pedidoA.representativeName.trim().localeCompare(pedidoB.representativeName.trim()),
    },
    {
      title: 'Condição de Pagamento',
      dataIndex: 'paymentConditionName',
      align: 'center' as 'center',
      sorter: (pedidoA: any, pedidoB: any) =>
        pedidoA.paymentConditionName.trim().localeCompare(pedidoB.paymentConditionName.trim()),
    },
    {
      title: 'Total',
      dataIndex: 'totalAmountOrder',
      align: 'right' as 'right',
      render: (text: string) => <Text>R$ {Number(text).toFixed(2).toString().replace('.', ',')}</Text>,
      sorter: (pedidoA: any, pedidoB: any) => pedidoA.totalAmountOrder - pedidoB.totalAmountOrder,
    },
    {
      title: 'Data Pedido',
      dataIndex: 'orderDate',
      render: (text: string) => <Text>{moment.utc(text).format('DD/MM/YYYY')}</Text>,
      sorter: (pedidoA: any, pedidoB: any) => {
        const date1 = new Date(pedidoA.orderDate);
        const date2 = new Date(pedidoB.orderDate);

        return date1.getTime() - date2.getTime();
      },
    },
    {
      title: 'Status',
      dataIndex: 'statusOrder',
      align: 'center' as 'center',
      render: (text: string) => {
        const status = returnOrderStatus(text);

        if (text === 'Attended') return <Tag color="green">{status}</Tag>;

        if (text === 'InProgress') return <Tag color="yellow">{status}</Tag>;

        if (text === 'Canceled') return <Tag color="red">{status}</Tag>;

        return <Tag>{status}</Tag>;
      },
      sorter: (pedidoA: any, pedidoB: any) => pedidoA.statusOrder.trim().localeCompare(pedidoB.statusOrder.trim()),
    },
  ];

  return (
    <div className="mt-4 ml-4">
      <Title level={5}>Pedidos</Title>
      <Table
        columns={columns}
        dataSource={orders}
        scroll={{ x: 800 }}
        pagination={{
          pageSize: 8,
          total: ordersTotal,
          showSizeChanger: false,
          showQuickJumper: false,
          onChange: (page: number) => loadOrdersByRepresentativeIdPaginated(actualRepresentative.code, page),
        }}
      />
    </div>
  );
};

export default Orders;
